import React, { createContext, useState } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [myOrgName, setMyOrgName] = useState("");//\"simplisys",
  const [baseUrl,setBaseUrl]= useState("") ///https://simplisysapi.vizionsys.com 
  const [token, setToken] = useState()
   const [tenantCode, setTenantCode] = useState(""); //vizionsys

  return (
    <AuthContext.Provider
      value={{ myOrgName, setMyOrgName, token, setToken, tenantCode, setTenantCode ,baseUrl,setBaseUrl}}
    >
      {children}
    </AuthContext.Provider>
  );
}
